// Copyright (c) 2017 Deere & Company

import * as ClaimSearchHelper from '../../shared/services/claim-search-helper';
import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/smart-accordion/components/accordion';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import ClaimSearchList from '../../claim-search/components/claim-search-list';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import {FormattedMessage} from 'react-intl';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

const AllClaimsPanel = (props, context) => {

    const claimStatusTitle = ClaimSearchHelper.mapClaimStatus(props.status);

    const allClaimsList = (
        <ClaimSearchList
            actions={props.actions}
            busyCounter={props.busyCounter}
            claims={props.allClaims}
            isEditable={false}
        />
    );

    const allClaimsTitle = (
        <span>
            <FormattedMessage id={claimStatusTitle}/>{` (${props.allClaims.length})`}
        </span>
    );

    return (props.status !== '9' || context.user.privacy.showWaitingForDealerInvoice) &&
        <Accordion
            accordion={props.claimsAccordion}
            body={allClaimsList}
            onAccordionToggle={props.onAccordionToggle}
            title={allClaimsTitle}
        />;

};

AllClaimsPanel.displayName = 'AllClaimsPanel';
AllClaimsPanel.propTypes = {
    actions: PropTypes.object,
    allClaims: PropTypes.arrayOf(PropTypes.instanceOf(ClaimSearchResult)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    claimsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    onAccordionToggle: PropTypes.func.isRequired,
    status: PropTypes.string
};
AllClaimsPanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default AllClaimsPanel;



// WEBPACK FOOTER //
// ./src/claim/all-claims/components/all-claims-panel.js